// extracted by mini-css-extract-plugin
export default {"checkbox":"ZFIq_B","checkboxError":"D_VQgY"};